import * as ActionTypes from '../../actions/ActionTypes';
import ManageFiltersRecord from '../../records/manage/ManageFiltersRecord';
export default function manageFilters(state = new ManageFiltersRecord(), {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_KNOWLEDGE_BASE_SUCCESS:
      return new ManageFiltersRecord();
    case ActionTypes.SELECT_ALL_ARTICLES:
      return state.set('selectedArticles', payload.selectedArticles);
    case ActionTypes.SELECT_ARTICLE:
      return state.update('selectedArticles', selectedArticles => selectedArticles.push(payload.article));
    case ActionTypes.SORT_TABLE_BY_COLUMN:
      {
        const {
          sortColumn,
          sortDir,
          offset
        } = payload;
        return state.merge({
          sortColumn,
          sortDir,
          offset
        });
      }
    case ActionTypes.UNSELECT_ALL_ARTICLES:
      return state.merge({
        allFilteredArticlesSelected: false,
        // @ts-expect-error ts-migrate(2740) FIXME: Type 'never[]' is missing the following properties... Remove this comment to see the full error message
        selectedArticles: []
      });
    case ActionTypes.UNSELECT_ARTICLE:
      return state.update('selectedArticles', selectedArticles => selectedArticles.delete(selectedArticles.indexOf(payload.article)));
    case ActionTypes.TOGGLE_SELECT_ALL_FILTERED_ARTICLES:
      return state.merge({
        allFilteredArticlesSelected: !state.allFilteredArticlesSelected,
        filteredArticlesCount: payload.count
      });
    case ActionTypes.FETCH_ARTICLES_SUCCESS:
      return state.set('filteredArticlesCount', payload.totalCount);
    case ActionTypes.UPDATE_OFFSET:
      return state.set('offset', payload.offset);
    case ActionTypes.UPDATE_SEARCH_TERM:
      {
        const {
          searchTerm,
          offset
        } = payload;
        return state.merge({
          searchTerm,
          offset
        });
      }
    case ActionTypes.UPDATE_CATEGORY_FILTER:
      {
        const {
          categoryIds,
          offset
        } = payload;
        return state.merge({
          categoryIds,
          offset
        });
      }
    case ActionTypes.UPDATE_AUTHOR_FILTER:
      {
        const {
          authorId,
          offset
        } = payload;
        return state.merge({
          authorId,
          offset
        });
      }
    case ActionTypes.UPDATE_VISIBILITY_FILTER:
      {
        const {
          visibility,
          offset
        } = payload;
        return state.merge({
          visibility,
          offset
        });
      }
    default:
      return state;
  }
}